


































































































































































import Vue from 'vue'
import {
  parseISO,
  differenceInDays,
  isValid as isValidDate,
  format,
  parseJSON,
  isValid,
} from 'date-fns'
import { DataTableHeader } from 'vuetify'
import { PropertyMap } from '@/components/gmap/'
import { ValidatedResponse } from '../../interfaces/app/ValueObjects'
import { getNestedValue } from '../../util/helpers'
import { MapMarker } from '../../interfaces/gmap/Map'
import client from '../../services/api/client'
import { formatMoneyFilter, numberToFixed } from '../../plugins/filters'
import { BuildingType } from '../../interfaces/valuation/types/BuildingValuationStep'

interface DataOptions {
  dialog: boolean
  selectedTransaction: any
  loading: boolean
  imageLoading: boolean
  images: string[]
  page: number
  pageCount: number
  itemsPerPage: number
  headers: DataTableHeader[]
}

export default Vue.extend({
  components: {
    PropertyMap,
  },
  props: {
    valuationNumber: {
      type: String,
      required: true,
    },
  },
  created() {
    this.loading = true
    this.$store
      .dispatch('valuationEdit/fetchAdvertisingData', this.valuationNumber)
      .finally(() => (this.loading = false))
  },
  data(): DataOptions {
    return {
      dialog: false,
      selectedTransaction: {},
      loading: false,
      imageLoading: false,
      images: [],
      page: 1,
      pageCount: 0,
      itemsPerPage: 10,
      headers: [
        { text: 'ID nabídky', value: 'transactionID', sortable: false },
        { text: 'Ulice', value: 'adresa', sortable: false, width: 200 },
        {
          text: 'Dispozice',
          value: 'category',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Plocha m²',
          value: 'usableArea',
          sortable: false,
          align: 'center',
        },
        { text: 'Vznik', value: 'created', sortable: false, align: 'center' },
        {
          text: 'Prodej',
          value: 'transactionDate',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Doba nabídky',
          value: 'duration',
          sortable: false,
          align: 'center',
        },
        {
          text: 'Cena celkem',
          value: 'priceTotal',
          sortable: false,
          width: 100,
        },
        { text: 'Cena za m²', value: 'price', sortable: false, width: 100 },
        { text: 'Podlaží', value: 'storey', sortable: false, align: 'center' },
        { text: 'Vlastnictví', value: 'ownership', sortable: false },
        {
          text: 'Vzdálenost od posuzované jednotky v m',
          value: 'distance',
          sortable: false,
          width: 50,
        },
        { text: 'Stav', value: 'objectState', sortable: false },
        {
          text: '',
          value: 'action',
          sortable: false,
        },
      ],
    }
  },
  computed: {
    transactions(): any {
      return this.$store.getters['valuationEdit/advertisingTransactions'].map(
        (transaction: any) => {
          transaction.usableArea =
            transaction.usableArea || transaction.unitArea || 1

          const created = parseISO(transaction.created)
          const transactionDate = parseISO(transaction.transactionDate)
          transaction.duration = ''
          if (isValidDate(created) && isValidDate(transactionDate)) {
            transaction.duration = `${differenceInDays(
              transactionDate,
              created
            )}d`
            transaction.created = format(created, 'd.M.y')
            transaction.transactionDate = format(transactionDate, 'd.M.y')
          }

          return transaction
        }
      )
    },
    attributes(): Array<{ key: string; text: string; value: string }> {
      return [
        {
          key: 'category',
          text: 'Dispozice',
          value: this.selectedTransaction.category || '',
        },
        {
          key: 'usableArea',
          text: 'Plocha m²',
          value:
            this.selectedTransaction.usableArea ||
            this.selectedTransaction.usableArea ||
            '',
        },
        {
          key: 'created',
          text: 'Vytvořeno',
          value: this.selectedTransaction.created || 'N/A',
        },
        {
          key: 'transactionDate',
          text: 'Prodej',
          value: this.selectedTransaction.transactionDate || 'N/A',
        },
        {
          key: 'duration',
          text: 'Doba nabídky',
          value: this.selectedTransaction.duration,
        },
        {
          key: 'priceTotal',
          text: 'Cena celkem',
          value: formatMoneyFilter(this.selectedTransaction.priceTotal),
        },
        {
          key: 'price',
          text: 'Cena za m²',
          value: formatMoneyFilter(this.selectedTransaction.price),
        },
        {
          key: 'distance',
          text: 'Vzdálenost od posuzované jednotky v m',
          value: numberToFixed(this.selectedTransaction.distance),
        },
        {
          key: 'building',
          text: 'Konstrukce',
          value: this.selectedTransaction.building || '',
        },
        {
          key: 'objectState',
          text: 'Stav',
          value: this.selectedTransaction.objectState || '',
        },
        {
          key: 'ownership',
          text: 'Vlastnictví',
          value: this.selectedTransaction.ownership || '',
        },
      ]
    },
    simpleAttributes(): string[] {
      const attributes = getNestedValue(
        this.selectedTransaction,
        ['attributes'],
        []
      )
      return Array.isArray(attributes) ? attributes : []
    },
    lat(): ValidatedResponse<number> {
      const lat = getNestedValue(this.selectedTransaction, ['lat'], false)
      if (!lat) {
        return { valid: false }
      }
      return { valid: true, value: Number(lat) }
    },
    lng(): ValidatedResponse<number> {
      const lng = getNestedValue(this.selectedTransaction, ['lng'], false)
      if (!lng) {
        return { valid: false }
      }
      return { valid: true, value: Number(lng) }
    },
    unitMarkerPosition(): ValidatedResponse<MapMarker['position']> {
      if (!this.lat.valid || !this.lng.valid) {
        return { valid: false }
      }
      return {
        valid: true,
        value: {
          lat: this.lat.value!,
          lng: this.lng.value!,
        },
      }
    },
    unitMarker(): MapMarker | undefined {
      if (this.unitMarkerPosition.valid) {
        const marker: MapMarker = {
          id: 1,
          position: this.unitMarkerPosition.value!,
          icon: require('@/assets/icons/map/pointer–blue.svg'),
        }

        return marker
      }
    },
    buildingType(): string {
      return this.$store.getters['valuationEdit/buildingType']
    },
    isBuildingTypeNew(): boolean {
      return this.buildingType === BuildingType.New
    },
  },
  methods: {
    showDetail(transaction: any): void {
      this.selectedTransaction = transaction
      this.dialog = true
    },
    hideDetail(): void {
      this.selectedTransaction = {}
      this.dialog = false
    },
    loadTransactionImages(): void {
      const transactionId = getNestedValue(this.selectedTransaction, [
        'transactionID',
      ])
      if (!transactionId || !this.dialog) {
        return
      }
      this.imageLoading = true
      client({
        url: `/v1/valuation/advertisingTransactions/images/${transactionId}`,
        method: 'GET',
      })
        .then(resp => {
          if (this.dialog) {
            this.images = resp.data
          }
        })
        .finally(() => {
          this.imageLoading = false
        })
    },
  },
  watch: {
    dialog(val: boolean) {
      if (!val) {
        this.selectedTransaction = {}
        this.images = []
      } else {
        this.loadTransactionImages()
      }
    },
  },
})
